import { Component, OnInit } from '@angular/core';
import { map } from 'rxjs/operators';
import { Breakpoints, BreakpointObserver } from '@angular/cdk/layout';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {


  ngOnInit() {

  } 

  /** Based on the screen size, switch from standard to one column per row */
  cards = this.breakpointObserver.observe(Breakpoints.Handset).pipe(
    map(({ matches }) => {
      if (matches) {
        return [
          { title: 'transactions', cols: 1, rows: 1, path:'/agent/reports/transactions' },
          { title: 'agents-report', cols: 1, rows: 1, path:'/agent/reports/agents-report' },
          { title: 'providers-report', cols: 1, rows: 1, path:'/agent/reports/providers-report' }
        ];
      }

      return [
        { title: 'transactions', cols: 2, rows: 1, path:'/agent/reports/transactions' },
        { title: 'agents-report', cols: 1, rows: 1, path:'/agent/reports/agents-report' },
        { title: 'providers-report', cols: 1, rows: 1, path:'/agent/reports/providers-report' }
      ];
    })
  );

  constructor(private breakpointObserver: BreakpointObserver) {}
}
